module.exports = __webpack_public_path__ + "img/google-icon.255362e3.svg";